
import { Component, Prop, Vue } from "vue-property-decorator";
import { openAnketPenceresi } from "@/components/infos/anketSso";
import KatkiPaneliButton from "@/components/infos/KatkiPaneliButton.vue";

interface KatkiPaneliTanitimMaddesi {
  ikon: string;
  baslik: string;
  aciklama: string;
}

/**
 * Katki Paneli ozelligini ilk giriste bir kez tanitan pop-up.
 *
 * Amaci ozelligi ogretmek degil, iki soruyu 4 saniyede cevaplamak:
 * "bu nedir" ve "nerede". Bu yuzden once ust cubuk temsili, sonra metin gelir.
 * Ne zaman gosterilecegi/kapatildiginin kaydi App.vue'nun sorumlulugundadir.
 */
@Component({
  components: { KatkiPaneliButton }
})
export default class KatkiPaneliTanitimDialog extends Vue {
  @Prop({ default: false }) value!: boolean;

  aciliyor: boolean = false;

  readonly maddeler: KatkiPaneliTanitimMaddesi[] = [
    {
      ikon: "mdi-lightbulb-on-outline",
      baslik: "Öneri ve talep iletin",
      aciklama: "Yeni özellik isteklerinizi ve iyileştirme fikirlerinizi kayıt altına alın."
    },
    {
      ikon: "mdi-thumb-up-outline",
      baslik: "Önceliği birlikte belirleyelim",
      aciklama: "Diğer kullanıcıların önerilerini oylayın; en çok destek alan talepler öne alınır."
    },
    {
      ikon: "mdi-progress-check",
      baslik: "Talebinizin durumunu izleyin",
      aciklama: "İlettiğiniz kaydın değerlendirme ve geliştirme aşamasını panelden takip edin."
    }
  ];

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  kapat() {
    this.dialog = false;
  }

  /**
   * Pencere, openAnketPenceresi'nin ilk satirinda tiklama jestiyle ayni gorevde
   * acilir; bu yuzden await'ten once ek is yapilmaz (pop-up engellenmesin).
   */
  async paneliAc() {
    this.aciliyor = true;
    try {
      await openAnketPenceresi(this.$http);
    } finally {
      this.aciliyor = false;
      this.kapat();
    }
  }
}
